import { useWatch } from 'react-hook-form'
import { StudentObervationCard } from '@/components/cards/student-observation'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'
import { Modal } from '../modal'

interface NotGrantReviewModalProps {
  isOpen: boolean
  setOpen: (value: boolean) => void
  formMethods: StudentRequestedCoursesFormMethods
  notGrantIsPending: boolean
  notGrantSubmit: () => void
}

export const NotGrantReviewModal = ({
  isOpen,
  setOpen,
  formMethods,
  notGrantIsPending,
  notGrantSubmit
}: NotGrantReviewModalProps) => {
  const watched = useWatch({
    control: formMethods.control,
    name: 'observation'
  })

  const disableSubmit = () => {
    if (watched) {
      if (watched.length !== 0) {
        return false
      }
    }

    return true
  }

  return (
    <Modal
      backButtonLabel="Cancelar"
      submitButtonLabel="Indeferir"
      submitButtonclassName="bg-destructive"
      submitButtonDisabled={disableSubmit()}
      title="Deferir Análise"
      isOpen={isOpen}
      description="Selecione um currículo disponível"
      pendingSubmit={notGrantIsPending}
      setOpen={setOpen}
      className="sm:max-w-none w-250"
      submitAction={() => notGrantSubmit()}
    >
      <p className="text-destructive font-bold">Indeferimento</p>
      <p className="mt-5">
        Esta ação irá indeferir a análise para o aluno.{' '}
        <strong>
          Não será mais possível reutilizar esta análise novamente.
        </strong>
      </p>
      <p className="mt-6">
        Para realizá-la é necessário que você{' '}
        <strong>escreva uma justificativa para o indeferimento,</strong>{' '}
        deixando claro para o aluno o motivo da negativa.
      </p>

      <div className="mt-5">
        <StudentObervationCard
          formMethods={formMethods}
          description="Escreva para o aluno uma justificativa para o indeferimento"
        />
      </div>
      <div className="font-bold mt-3">
        Deseja realmente <span className="text-destructive">indeferir</span> a
        análise?
      </div>
    </Modal>
  )
}
